/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */

import * as coreHttp from "@azure/core-http";

export const activity: coreHttp.OperationURLParameter = {
  parameterPath: "activity",
  mapper: {
    required: true,
    serializedName: "activity",
    type: {
      name: "String"
    }
  }
};
export const alertId: coreHttp.OperationURLParameter = {
  parameterPath: "alertId",
  mapper: {
    required: true,
    serializedName: "alertId",
    type: {
      name: "String"
    }
  }
};
export const alertTypes: coreHttp.OperationQueryParameter = {
  parameterPath: [
    "options",
    "alertTypes"
  ],
  mapper: {
    serializedName: "AlertTypes",
    type: {
      name: "Sequence",
      element: {
        type: {
          name: "Enum",
          allowedValues: [
            "Itp",
            "LocalDevice",
            "CrossDevice",
            "SecureConnection",
            "Credit",
            "AutoSampleSubmission"
          ]
        }
      }
    }
  },
  collectionFormat: coreHttp.QueryCollectionFormat.Multi
};
export const apiVersion: coreHttp.OperationQueryParameter = {
  parameterPath: "apiVersion",
  mapper: {
    required: true,
    isConstant: true,
    serializedName: "api-version",
    defaultValue: '1.0',
    type: {
      name: "String"
    }
  }
};
export const breachedType: coreHttp.OperationQueryParameter = {
  parameterPath: [
    "options",
    "breachedType"
  ],
  mapper: {
    serializedName: "breachedType",
    type: {
      name: "Enum",
      allowedValues: [
        "SocialSecurityNumber",
        "EmailAddress",
        "MedicalId",
        "CreditCard",
        "CreditCardCVN",
        "BankAccountNumber",
        "DriverLicenseNumber",
        "PassportNumber",
        "NationalId",
        "InternationalBankAccountNumber",
        "RetailCardNumber",
        "BankRoute",
        "EbayPassword",
        "Password",
        "PhoneExt",
        "EbayUserId",
        "CardExpYear",
        "CreditCardPin",
        "BankingPin",
        "DriversLicenseState",
        "BankingPassword",
        "BankUserId",
        "DateOfBirth",
        "MothersMaidenName",
        "CellPhone",
        "WorkPhone",
        "HomePhone",
        "PaypalPassword",
        "UserId",
        "BankName",
        "CardExpDay",
        "LastName",
        "BankPhone",
        "Cardtype",
        "MiddleName",
        "Phone",
        "PaypalUserId",
        "CardExpDate",
        "CardExpMonth",
        "CardName",
        "FirstName",
        "CardAddr",
        "MedicalProvider",
        "PassportIssueDate",
        "PassportExpDate",
        "PassportCountry",
        "NationalCountry",
        "Address",
        "NotApplicable"
      ]
    }
  }
};
export const breachId: coreHttp.OperationURLParameter = {
  parameterPath: "breachId",
  mapper: {
    required: true,
    serializedName: "breachId",
    type: {
      name: "String"
    }
  }
};
export const breachIds: coreHttp.OperationQueryParameter = {
  parameterPath: [
    "options",
    "breachIds"
  ],
  mapper: {
    serializedName: "BreachIds",
    type: {
      name: "Sequence",
      element: {
        type: {
          name: "String"
        }
      }
    }
  },
  collectionFormat: coreHttp.QueryCollectionFormat.Multi
};
export const campaignId: coreHttp.OperationURLParameter = {
  parameterPath: "campaignId",
  mapper: {
    required: true,
    serializedName: "campaignId",
    type: {
      name: "String"
    }
  }
};
export const cleanupSubCategory: coreHttp.OperationURLParameter = {
  parameterPath: "cleanupSubCategory",
  mapper: {
    required: true,
    serializedName: "cleanupSubCategory",
    type: {
      name: "Enum",
      allowedValues: [
        "FirstUserWarningNotificationEvent",
        "SecondUserWarningNotificationEvent",
        "ThirdUserWarningNotificationEvent",
        "FirstOrganizerWarningNotificationEvent",
        "SecondOrganizerWarningNotificationEvent",
        "ThirdOrganizerWarningNotificationEvent",
        "UserCleanupNotificationEvent",
        "OrganizerCleanupMinorNotificationEvent",
        "OrganizerCleanupNotMinorNotificationEvent"
      ]
    }
  }
};
export const countryCode: coreHttp.OperationQueryParameter = {
  parameterPath: [
    "options",
    "countryCode"
  ],
  mapper: {
    serializedName: "countryCode",
    type: {
      name: "String"
    }
  }
};
export const creditAlertId: coreHttp.OperationURLParameter = {
  parameterPath: "creditAlertId",
  mapper: {
    required: true,
    serializedName: "creditAlertId",
    type: {
      name: "String"
    }
  }
};
export const creditMonitoringIds: coreHttp.OperationQueryParameter = {
  parameterPath: [
    "options",
    "creditMonitoringIds"
  ],
  mapper: {
    serializedName: "CreditMonitoringIds",
    type: {
      name: "Sequence",
      element: {
        type: {
          name: "String"
        }
      }
    }
  },
  collectionFormat: coreHttp.QueryCollectionFormat.Multi
};
export const csid: coreHttp.OperationURLParameter = {
  parameterPath: "csid",
  mapper: {
    required: true,
    serializedName: "csid",
    type: {
      name: "String"
    }
  }
};
export const destroy: coreHttp.OperationQueryParameter = {
  parameterPath: [
    "options",
    "destroy"
  ],
  mapper: {
    serializedName: "destroy",
    defaultValue: false,
    type: {
      name: "Boolean"
    }
  }
};
export const detectionId: coreHttp.OperationURLParameter = {
  parameterPath: "detectionId",
  mapper: {
    required: true,
    serializedName: "detectionId",
    type: {
      name: "String"
    }
  }
};
export const deviceId: coreHttp.OperationURLParameter = {
  parameterPath: "deviceId",
  mapper: {
    required: true,
    serializedName: "deviceId",
    type: {
      name: "String"
    }
  }
};
export const deviceIds: coreHttp.OperationQueryParameter = {
  parameterPath: [
    "options",
    "deviceIds"
  ],
  mapper: {
    serializedName: "DeviceIds",
    type: {
      name: "Sequence",
      element: {
        type: {
          name: "String"
        }
      }
    }
  },
  collectionFormat: coreHttp.QueryCollectionFormat.Multi
};
export const email: coreHttp.OperationQueryParameter = {
  parameterPath: [
    "options",
    "email"
  ],
  mapper: {
    serializedName: "email",
    type: {
      name: "String"
    }
  }
};
export const entityId: coreHttp.OperationURLParameter = {
  parameterPath: "entityId",
  mapper: {
    required: true,
    serializedName: "entityId",
    type: {
      name: "String"
    }
  }
};
export const excludeDevice: coreHttp.OperationQueryParameter = {
  parameterPath: [
    "options",
    "excludeDevice"
  ],
  mapper: {
    serializedName: "ExcludeDevice",
    type: {
      name: "String"
    }
  }
};
export const familyPermissionType: coreHttp.OperationURLParameter = {
  parameterPath: "familyPermissionType",
  mapper: {
    required: true,
    serializedName: "familyPermissionType",
    type: {
      name: "Enum",
      allowedValues: [
        "DevicesStatus",
        "ITPManage",
        "ITPRead",
        "CreditMonitoringRead",
        "CreditMonitoringManage"
      ]
    }
  }
};
export const forceDelete: coreHttp.OperationQueryParameter = {
  parameterPath: [
    "options",
    "forceDelete"
  ],
  mapper: {
    serializedName: "forceDelete",
    type: {
      name: "Boolean"
    }
  }
};
export const id: coreHttp.OperationURLParameter = {
  parameterPath: "id",
  mapper: {
    required: true,
    serializedName: "id",
    type: {
      name: "String"
    }
  }
};
export const includeDeletedDevices0: coreHttp.OperationQueryParameter = {
  parameterPath: [
    "options",
    "includeDeletedDevices"
  ],
  mapper: {
    serializedName: "includeDeletedDevices",
    defaultValue: false,
    type: {
      name: "Boolean"
    }
  }
};
export const includeDeletedDevices1: coreHttp.OperationQueryParameter = {
  parameterPath: [
    "options",
    "includeDeletedDevices"
  ],
  mapper: {
    serializedName: "IncludeDeletedDevices",
    type: {
      name: "Boolean"
    }
  }
};
export const includeFamily0: coreHttp.OperationQueryParameter = {
  parameterPath: [
    "options",
    "includeFamily"
  ],
  mapper: {
    serializedName: "IncludeFamily",
    type: {
      name: "Boolean"
    }
  }
};
export const includeFamily1: coreHttp.OperationQueryParameter = {
  parameterPath: [
    "options",
    "includeFamily"
  ],
  mapper: {
    serializedName: "includeFamily",
    defaultValue: false,
    type: {
      name: "Boolean"
    }
  }
};
export const includeFamilyDevices: coreHttp.OperationQueryParameter = {
  parameterPath: [
    "options",
    "includeFamilyDevices"
  ],
  mapper: {
    serializedName: "IncludeFamilyDevices",
    type: {
      name: "Boolean"
    }
  }
};
export const iOSDeviceModel: coreHttp.OperationURLParameter = {
  parameterPath: "iOSDeviceModel",
  mapper: {
    required: true,
    serializedName: "iOSDeviceModel",
    type: {
      name: "String"
    }
  }
};
export const isActive: coreHttp.OperationQueryParameter = {
  parameterPath: [
    "options",
    "isActive"
  ],
  mapper: {
    serializedName: "IsActive",
    type: {
      name: "Boolean"
    }
  }
};
export const isDismissed: coreHttp.OperationQueryParameter = {
  parameterPath: [
    "options",
    "isDismissed"
  ],
  mapper: {
    serializedName: "IsDismissed",
    type: {
      name: "Boolean"
    }
  }
};
export const itmBreachesGrouping: coreHttp.OperationQueryParameter = {
  parameterPath: [
    "options",
    "itmBreachesGrouping"
  ],
  mapper: {
    serializedName: "ItmBreachesGrouping",
    type: {
      name: "Boolean"
    }
  }
};
export const localDeviceId: coreHttp.OperationQueryParameter = {
  parameterPath: [
    "options",
    "localDeviceId"
  ],
  mapper: {
    serializedName: "LocalDeviceId",
    type: {
      name: "String"
    }
  }
};
export const pageNumber: coreHttp.OperationQueryParameter = {
  parameterPath: [
    "options",
    "pageNumber"
  ],
  mapper: {
    serializedName: "PageNumber",
    type: {
      name: "Number"
    }
  }
};
export const pageSize: coreHttp.OperationQueryParameter = {
  parameterPath: [
    "options",
    "pageSize"
  ],
  mapper: {
    serializedName: "PageSize",
    type: {
      name: "Number"
    }
  }
};
export const phoneNumber: coreHttp.OperationQueryParameter = {
  parameterPath: [
    "options",
    "phoneNumber"
  ],
  mapper: {
    serializedName: "phoneNumber",
    type: {
      name: "String"
    }
  }
};
export const photoSizeId: coreHttp.OperationURLParameter = {
  parameterPath: "photoSizeId",
  mapper: {
    required: true,
    serializedName: "photoSizeId",
    type: {
      name: "String"
    }
  }
};
export const points: coreHttp.OperationQueryParameter = {
  parameterPath: [
    "options",
    "points"
  ],
  mapper: {
    serializedName: "points",
    defaultValue: 500,
    type: {
      name: "Number"
    }
  }
};
export const puid: coreHttp.OperationURLParameter = {
  parameterPath: "puid",
  mapper: {
    required: true,
    serializedName: "puid",
    type: {
      name: "String"
    }
  }
};
export const recommendationId0: coreHttp.OperationURLParameter = {
  parameterPath: "recommendationId",
  mapper: {
    required: true,
    serializedName: "recommendationId",
    type: {
      name: "Enum",
      allowedValues: [
        "EnableMFA",
        "ChangeSharedPasswords",
        "ContactRestorationServices",
        "ChangePassword",
        "CheckUnfamiliarTransactionsBank",
        "CheckUnfamiliarTransactionsCreditCard",
        "CheckUnfamiliarTransactionsEbay",
        "CheckUnfamiliarClaims",
        "ChangeSecurityQuestionsMothersName",
        "SelectNewPinBank",
        "RequestNewCard",
        "RequestNewCardRetailCard",
        "SelectNewPinCreditCard",
        "ChangeSecurityQuestionsBirthday",
        "ReviewCreditReports",
        "ReportStolenNationalId",
        "ReportStolenPassport",
        "CheckUnfamiliarTransactionsPayPal",
        "CheckUnfamiliarTransactionsRetail",
        "ReportIdTheft",
        "PlaceCreditFreeze",
        "UpdateAutomaticPayments",
        "ContactPhoneProvider",
        "DotNotCall",
        "EnableMFABank",
        "EnableMFABankPassword",
        "EnableMFAEbay",
        "EnableMFAPaypal",
        "ReviewCreditReportsAndContactRestorationServices",
        "ChangePasswordAndUsePasswordManager",
        "ChangeSharedPasswordsWithExplanation"
      ]
    }
  }
};
export const recommendationId1: coreHttp.OperationURLParameter = {
  parameterPath: "recommendationId",
  mapper: {
    required: true,
    serializedName: "recommendationId",
    type: {
      name: "Enum",
      allowedValues: [
        "SigninToAccountAndCheckDetails",
        "CheckJointOwnerOfCardOrAccount",
        "ContactCreditorForMoreInformation",
        "StillDontRecognizeActivityFileDisputeWithExperian",
        "FileADisputeWithExperian",
        "AppliedOrCosignedForNewServiceAccountOrLoan",
        "AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation",
        "ContactInquirerByMail",
        "ContactInquirerCompany",
        "ContactIdentityValidatorCompany",
        "ContactCompanyForMoreInformation",
        "SSNTrace",
        "CreditFileLocked",
        "CreditFileUnlocked",
        "CreditFileUnlockedDueToMembershipChange",
        "InquiryBlocked",
        "ContactExperianCreditLockStatus",
        "AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity"
      ]
    }
  }
};
export const recommendationId2: coreHttp.OperationURLParameter = {
  parameterPath: "recommendationId",
  mapper: {
    required: true,
    serializedName: "recommendationId",
    type: {
      name: "String"
    }
  }
};
export const settingType: coreHttp.OperationURLParameter = {
  parameterPath: "settingType",
  mapper: {
    required: true,
    serializedName: "settingType",
    type: {
      name: "Enum",
      allowedValues: [
        "OnboardingStatus",
        "DismissedDevices",
        "AvatarColors",
        "DeviceIdsWithFixedAlerts"
      ]
    }
  }
};
export const severity: coreHttp.OperationQueryParameter = {
  parameterPath: [
    "options",
    "severity"
  ],
  mapper: {
    serializedName: "Severity",
    type: {
      name: "Sequence",
      element: {
        type: {
          name: "Enum",
          allowedValues: [
            "Info",
            "Low",
            "Medium",
            "High",
            "Important",
            "Critical"
          ]
        }
      }
    }
  },
  collectionFormat: coreHttp.QueryCollectionFormat.Multi
};
export const sortBy: coreHttp.OperationQueryParameter = {
  parameterPath: [
    "options",
    "sortBy"
  ],
  mapper: {
    serializedName: "SortBy",
    type: {
      name: "Enum",
      allowedValues: [
        "LastReportedDateTime",
        "Severity"
      ]
    }
  }
};
export const sortOrder: coreHttp.OperationQueryParameter = {
  parameterPath: [
    "options",
    "sortOrder"
  ],
  mapper: {
    serializedName: "SortOrder",
    type: {
      name: "Enum",
      allowedValues: [
        "Desc",
        "Asc"
      ]
    }
  }
};
export const state: coreHttp.OperationQueryParameter = {
  parameterPath: [
    "options",
    "state"
  ],
  mapper: {
    serializedName: "state",
    type: {
      name: "Enum",
      allowedValues: [
        "Remediated",
        "FalsePositive",
        "NotRelevant",
        "New"
      ]
    }
  }
};
export const status: coreHttp.OperationQueryParameter = {
  parameterPath: [
    "options",
    "status"
  ],
  mapper: {
    serializedName: "Status",
    type: {
      name: "Sequence",
      element: {
        type: {
          name: "Enum",
          allowedValues: [
            "None",
            "Allowed",
            "Blocked",
            "Quarantined",
            "Removed",
            "Bypassed",
            "Threat",
            "Compromised",
            "InProgress",
            "Complete",
            "Cleaned",
            "Restored",
            "RemediationFailed",
            "Detected",
            "ProtectionOn",
            "ProtectionOff",
            "NeedsAttention",
            "Archived"
          ]
        }
      }
    }
  },
  collectionFormat: coreHttp.QueryCollectionFormat.Multi
};
export const token: coreHttp.OperationQueryParameter = {
  parameterPath: [
    "options",
    "token"
  ],
  mapper: {
    serializedName: "token",
    type: {
      name: "String"
    }
  }
};
export const trustedNetworkId: coreHttp.OperationURLParameter = {
  parameterPath: "trustedNetworkId",
  mapper: {
    required: true,
    serializedName: "trustedNetworkId",
    type: {
      name: "String"
    }
  }
};
export const type: coreHttp.OperationQueryParameter = {
  parameterPath: "type",
  mapper: {
    required: true,
    serializedName: "type",
    type: {
      name: "Enum",
      allowedValues: [
        "MultiDeviceRecommendationSelf",
        "MultiDeviceRecommendationFamily",
        "VpnRecommendation",
        "IntrigueSpam",
        "ITMAwareness",
        "CMAwareness",
        "RewardOffer",
        "RewardsSweepstake"
      ]
    }
  }
};
export const updateExternal: coreHttp.OperationQueryParameter = {
  parameterPath: [
    "options",
    "updateExternal"
  ],
  mapper: {
    serializedName: "updateExternal",
    defaultValue: true,
    type: {
      name: "Boolean"
    }
  }
};
export const userIds: coreHttp.OperationQueryParameter = {
  parameterPath: [
    "options",
    "userIds"
  ],
  mapper: {
    serializedName: "UserIds",
    type: {
      name: "Sequence",
      element: {
        type: {
          name: "String"
        }
      }
    }
  },
  collectionFormat: coreHttp.QueryCollectionFormat.Multi
};
export const variation: coreHttp.OperationQueryParameter = {
  parameterPath: [
    "options",
    "variation"
  ],
  mapper: {
    serializedName: "variation",
    type: {
      name: "String"
    }
  }
};
export const warningPeriodDurationInDays: coreHttp.OperationURLParameter = {
  parameterPath: "warningPeriodDurationInDays",
  mapper: {
    required: true,
    serializedName: "warningPeriodDurationInDays",
    type: {
      name: "Number"
    }
  }
};
